import { AbstractControl, ValidationErrors } from '@angular/forms';

export function asciiTextValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const isValid = /^[\d\sA-Za-z]*$/.test(value);
    return isValid ? null : { asciiValidator: { value: 'Invalid characters. Only digits, spaces, and ASCII letters are allowed.' } };
};
